import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledCalendarEvent = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  z-index: 5;
  ${props =>
    props.transform ? `transform: translateY(${props.transform}px)` : ''};
  ${props =>
    props.transition &&
    `
    transition: 0.5s ease-in-out;
  `};
  background-color: ${props => props.theme.colors.grayLight};

  ${mediaqueries.greaterThan('desktop')`
    display:none;
  `};
`;

const StyledCalendarEventHour = StyledCalendarEvent.extend`
  bottom: auto;
  top: 0;
  height: 100%;
  ${mediaqueries.greaterThan('mobile')`
    height: 100%;
  `};
  ${mediaqueries.greaterThan('desktop')`  
    height: 100vh;
  `};
`;

const StyledCalendarEventNot = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.dark};
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  height: auto;
  margin: 0;
  padding: ${rem('10px')};
  text-align: center;
  text-transform: uppercase;

  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('157px')};
    margin: ${rem('30px')} 0 0;
  `};

  ${mediaqueries.greaterThan('desktop')`
    align-items: center;
    margin: ${rem('70px')} auto 0;
    width: ${rem('170px')};
  `};
`;

const StyleIconNotEvent = styled(Icon)`
  margin: ${rem('10px')} 0 0;

  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('54px')};
    width: ${rem('54px')};
  `};
`;

const StyledListEvent = styled.ul`
  font-size: ${rem('14px')};
  margin: 0;
  padding: 0;

  ${mediaqueries.greaterThan('desktop')`
    display: list-item;
    margin-top: ${rem('60px')};
    padding-left: ${rem('40px')};
  `};
`;

const StyledListEventItem = styled.li`
  color: ${props => props.theme.colors.dark};
  display: block;
  padding: ${rem('15px')} ${rem('25px')};
  position: relative;

  :before {
    background-color: ${props => props.theme.colors.activeBlue};
    border-radius: 50%;
    border: ${rem('2px')} solid ${props => props.theme.colors.success};
    height: ${rem('7px')};
    left: ${rem('10px')};
    top: ${rem('23px')};
    width: 0.47rem;
  }

  ${mediaqueries.greaterThan('mobile')`
    display: flex;
    padding: ${rem('15px')} ${rem('30px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    border: none;
    display: list-item;
    list-style-type: disc;
    padding-left: 0; 
  `};
`;

const StyledListEventName = styled.span`
  font-family: ${props => props.theme.fonts.medium};
`;

const StyledListEventHours = styled.span`
  font-family: ${props => props.theme.fonts.book};
  padding-left: 0;

  :after {
    content: '/';
    font-family: ${props => props.theme.fonts.bold};
    margin: 0 10px;
  }

  :last-child {
    :after {
      content: none;
    }
  }

  ${mediaqueries.greaterThan('desktop')`
    display: block;
    :after {
      content: none;
  `};
`;

const StyledDragIcon = styled.div`
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayDark};
  border-top: ${rem('1px')} solid ${props => props.theme.colors.grayDark};
  cursor: pointer;
  display: block;
  height: ${rem('4px')};
  position: absolute;
  top: ${rem('5px')};
  left: 50%;
  width: ${rem('18px')};
  margin: ${rem('5px')} 0 0 ${rem('-9px')};
  ${mediaqueries.greaterThan('desktop')`
    display:none;
  `};
`;

export {
  StyledCalendarEvent,
  StyledCalendarEventHour,
  StyledCalendarEventNot,
  StyleIconNotEvent,
  StyledListEvent,
  StyledListEventName,
  StyledListEventItem,
  StyledListEventHours,
  StyledDragIcon
};
